/* tslint:disable */
/* eslint-disable */
/* @relayHash d134abe1216ea7e761198607af4a2433 */

import { ConcreteRequest } from "relay-runtime";
export type REJECTION_REASON_CODE = "ABUSIVE" | "AD" | "BANNED_WORD" | "HARASSMENT_BULLYING" | "HATE_SPEECH" | "ILLEGAL_CONTENT" | "IRRELEVANT_CONTENT" | "MISINFORMATION" | "OFFENSIVE" | "OTHER" | "SPAM" | "%future added value";
export type BanUserInput = {
    userID: string;
    clientMutationId: string;
    message: string;
    siteIDs?: Array<string> | null;
    rejectExistingComments?: boolean | null;
    rejectionReason?: RejectCommentReasonInput | null;
};
export type RejectCommentReasonInput = {
    code: REJECTION_REASON_CODE;
    legalGrounds?: string | null;
    detailedExplanation?: string | null;
    customReason?: string | null;
};
export type BanUserMutationVariables = {
    input: BanUserInput;
};
export type BanUserMutationResponse = {
    readonly banUser: {
        readonly user: {
            readonly id: string;
            readonly status: {
                readonly ban: {
                    readonly active: boolean;
                    readonly sites: ReadonlyArray<{
                        readonly id: string;
                    }> | null;
                };
                readonly suspension: {
                    readonly active: boolean;
                };
                readonly warning: {
                    readonly active: boolean;
                };
                readonly premod: {
                    readonly active: boolean;
                };
            };
        };
        readonly clientMutationId: string;
    };
};
export type BanUserMutation = {
    readonly response: BanUserMutationResponse;
    readonly variables: BanUserMutationVariables;
};



/*
mutation BanUserMutation(
  $input: BanUserInput!
) {
  banUser(input: $input) {
    user {
      id
      status {
        ban {
          active
          sites {
            id
          }
        }
        suspension {
          active
        }
        warning {
          active
        }
        premod {
          active
        }
      }
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any), v3 = [
        (v2 /*: any*/)
    ], v4 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "BanUserPayload",
            "kind": "LinkedField",
            "name": "banUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Site",
                                            "kind": "LinkedField",
                                            "name": "sites",
                                            "plural": true,
                                            "selections": [
                                                (v1 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SuspensionStatus",
                                    "kind": "LinkedField",
                                    "name": "suspension",
                                    "plural": false,
                                    "selections": (v3 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WarningStatus",
                                    "kind": "LinkedField",
                                    "name": "warning",
                                    "plural": false,
                                    "selections": (v3 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PremodStatus",
                                    "kind": "LinkedField",
                                    "name": "premod",
                                    "plural": false,
                                    "selections": (v3 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "BanUserMutation",
            "selections": (v4 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "BanUserMutation",
            "selections": (v4 /*: any*/)
        },
        "params": {
            "id": "d134abe1216ea7e761198607af4a2433",
            "metadata": {},
            "name": "BanUserMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'f64e2a9acfaa8468dcd1740f97b79459';
export default node;
